<template>
    <div class="def-input"
            :class="{ 'def-input_transform': isTransform }"
    >
        <input :type="type"
               class="def-input__input"
               :name="name"
               :placeholder="placeholder"
               :required="required"
               :value="localValue"
               :autocomplete="autocomplete"
               :id="id"
               :form="form"
               :class="{ 'def-validation__invalid': !isValid || isError}"
               :readonly="readonly"
               :pattern="pattern"
               @input="handlerInput"
               @click="({target}) => $emit('click', target.value)"
               @keypress="({target}) => $emit('keypress', target.value)"
               @keydown="({target}) => $emit('keydown', target.value)"
               @keyup="(e) => $emit('keyup', e)"
               @invalid.prevent="handlerInvalid"
               @change="handlerChange"
               @blur="handlerBlur"
               @focus="handlerFocus"
        >
        <label :for="id" class="def-input__label">{{label}}</label>

<!--        <span v-if="required">-->
<!--            <slot />-->
<!--            <br>-->
<!--            <SlideUpDown :modelValue="!isValid">-->
<!--                <span class="def-input__invalid">{{ invalidText }}</span>-->
<!--            </SlideUpDown>-->
<!--        </span>-->
    </div>
</template>

<script>
    export default {
        name: 'def-input',
        props: {
            name,
            placeholder: {
                type: String,
            },
            required: {
                type: Boolean,
            },
            value: {
                type: String,
            },
            autocomplete: {
                type: String,
            },
            invalidText: {
                type: String,
            },
            id: {
                type: String || Number,
            },
            label: {
                type: String,
            },
            form: {
                type: String,
            },
            type:{
                type: String,
                default: () => 'text',
            },
            readonly: {
                type: String,
            },
            isError: {
                type: Boolean,
                default: false
            },
            pattern: {
                type: [String, null],
                default: null,
            }
        },
        data() {
            return {
                isValid: true,
                localValue: this.value,
                isTransform: this.value?.length > 0,
            }
        },
        methods: {

            handlerInvalid(e) {
                this.isValid = false;
                this.$emit('invalid', e);
            },
            handlerBlur(e) {
                const target = e.target;
                if (target.checkValidity()) {
                    this.isValid = true;
                }

                this.$emit('blur', e);

                if (target.value.length === 0) {
                    this.isTransform = false;
                }
            },
            handlerFocus(e) {
                this.$emit('focus', e);
                this.isValid = true;
                this.isTransform = true;
            },
            handlerChange(e){
                const target = e.target;

                if (target.checkValidity()) {
                    this.isValid = true;
                }
                this.localValue = target.value;
                this.isTransform = target.value.length > 0;
            },
            handlerInput(e){
                const target = e.target;

                this.localValue = target.value;
                this.isTransform = target.value.length > 0;
            }
        },
        watch: {
            isValid(newValue) {
                if (this.error) {
                    if (!newValue) {
                        this.$refs['error'].classList.add('def-input-error')
                    } else {
                        this.$refs['error'].classList.remove('def-input-error')
                    }
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .def-input{
        position: relative;

        &__input{
            width: 100%;
            padding: 0 16px;
            height: 56px;
            font-size: rem(16);
            border: 1px solid #DFDFDF;
            font-weight: 500;
            color: #757575;
        }
        &__label{
            pointer-events: none;
            position: absolute;
            z-index: 1;
            padding-left: 16px;
            left: 0;
            line-height: 1em;
            transition: .2s linear transform, .2s linear font-size, .2s linear top;
            cursor: text;
            font-size: 16px;
            top: 50%;
            transform: translateY(-50%);
            color: #757575;
            white-space: nowrap;
            overflow: hidden;
            display: block;
            max-width: calc(100% - 16px);
            text-overflow: ellipsis;
            text-transform: lowercase;
            &:first-letter{
                text-transform: uppercase;
            }
        }

        &_transform{
            .def-input__label{
                font-size: 12px;
                top: 6px;
                transform: translateY(0);
            }
        }

        &::placeholder{
            color: #757575;
        }
        &__invalid{
            color: #C80024;
            margin-bottom: 10px;
            display: inline-block;
        }
    }
</style>